module.exports = "<div >\r\n   <!-- Sidebar -->\r\n    <app-header></app-header>\r\n\r\n   <!-- /#sidebar-wrapper -->\r\n\r\n   <!-- Page Content -->\r\n   <div id=\"page-content-wrapper\">\r\n      <app-sidebar></app-sidebar>\r\n      <div id=\"wrapper\">\r\n          <router-outlet></router-outlet>\r\n      </div>\r\n   </div>\r\n    <!-- Page Content Ends -->\r\n    <app-footer></app-footer>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.html
// module id = 1088
// module chunks = 1